<template>
    <bita-modal
        :id="modalId"
        :title="title"
        :modal-lg="true"
        :isLoading="isLoading"
        @close="onCloseModal"
    >
        <div slot="body">
            <bita-form ref="form">
                <div slot="body">
                    <div class="row">
                      <bita-select
                          id="loadparent"
                          name="loadparent"
                          label="دسته بندی"
                          ref="selectLoadParent"
                          rules="required"
                          validation-container-class="col-6"
                          input-class="form-control"
                          :data-source="loadParent"
                          data-text-field="name"
                          data-value-field="id"
                          v-model="updateData.parent_id"
                          @change="(e) => getChildLoad(e)"
                      />
                      <Spinner
                          :is-loading="isLoadingChildLoad"
                          class-name="col-6"
                          styleName="align-self: center;"
                      />
                      <bita-select
                          v-show="isLoadingChildLoad === false "
                          id="load"
                          name="load"
                          label="بار"
                          ref="selectLoad"
                          rules="required"
                          validation-container-class="col-6"
                          input-class="form-control"
                          :data-source="loadChild"
                          data-text-field="name"
                          data-value-field="id"
                          v-model="updateData.id"
                      />
                    </div>
                    <div class="row">
                    <bita-bootbutton
                        type="primary"
                        title="افزودن بار"
                        icon="fa fa-check"
                        btn-width="150px"
                        @click.native="handleSubmit()"
                    />
                    </div>
                </div>
            </bita-form>
            <div class="row">
              <bita-grid v-if="ownerData.id" :auto-bind="false" :pageSize="10" ref="ownerloadgrid" :columns="gridColumns" :read-data="readData" :hasRow="false" />
            </div>
        </div>
    </bita-modal>
</template>
<script>
import Spinner from "../../../components/Spinner";
export default {
  components: { Spinner },
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    propsData: {},
    propsLoad: {},
    propsLoadParent: {},
  },
  data() {
      return {
        isLoadingGrid: false,
        isLoadingChildLoad: false,
        ownerData: {},
        loadDatas: {},
        loadParent: {},
        loadChild: {},
        updateData: {},
        gridColumns: [
            { title: "#", template: this.$getTemplate, width: "40px" },
            { field: "name", title: "نام"},
            { field: "parent.name", title: " دسته بندی", template: (e) => e.parent_item ? e.parent_item.name : '-' },
            {
            title: "عملیات",
            command: [],
            },
        ],
      }
  },
  mounted() {
    this.gridColumns[this.gridColumns.length - 1].command = this.gridCommands();
  },
  watch: {
    propsData: function(_data){
        this.ownerData = _data;
    },
    propsLoadParent: function(_data){
      this.loadParent = _data;
    }
  },
  methods: {
    onCloseModal() {

    },
    readData(e) {
      this.$resetGrid();
      this.isLoadingGrid = true;
      this.$persistClient("get", `owners/${this.ownerData.id}/loads`)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success([]);
        })
        .finally(() => {
          this.isLoadingGrid = false;
        });
    },
    loadData() {
      this.$refs.ownerloadgrid.loadDataSource();
    },
    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },
    delete(e) {
      let load = this.$refs.ownerloadgrid.getSelectedGridRow(e);
      this.$persistClient("delete", `owners/${this.ownerData.id}/owner-load/${load.id}`)
      .then((res) => {
        this.$izitoast("success", "موفق", res.data.message);
        this.loadData();
      })
    },
    handleSubmit() {
    this.$refs.form.validate().then((result) => {
        if(result){
          let data = {
            owner_id: this.ownerData.id,
          };
          this.$persistClient("patch", `loads/${this.updateData.id}`, data)
          .then((res) => {
            this.$izitoast("success", "موفق", res.data.message);
            this.loadData();
          })
          .finally(() => {})
        }
      })
    },
    getChildLoad(e) {
    },
    getChildLoad(ID) {
      this.isLoadingChildLoad = true;
      this.$persistClient("get", `loads?filter[parentItem]=${ID}`)
      .then((res) => {
        this.loadChild = res.data
      })
      .finally((res) => {
        this.isLoadingChildLoad = false;
      })
    }
  }
};
</script>